import { createSingleComponentApp } from '../util/single-component-app';
import { createViewsetStoreModule } from '../stores/viewset';
import StoresOverview from '../components/StoresOverview.vue';

export async function createApp({ context }) {
  const { app, router, store } = await createSingleComponentApp({
    // Which component te render
    component: StoresOverview,
    // Initial component properties
    props: {
      viewURL: context.view_url
    },
    // Country code to make sure API requests contain the right cookie
    countryCode: context.country_code,
    // Language code to define which translations to fetch
    languageCode: context.language_code,
    // Base URL
    baseURL: context.base_url,
    // Store to sync data between SSR and client
    store: {
      modules: {
        viewset: createViewsetStoreModule({
          baseURL: context.base_url,
          // Base URL of viewset
          url: '/api/v0/catalog/store/',
        }),
        countries: createViewsetStoreModule({
          baseURL: context.base_url,
          // Base URL of viewset
          url: '/api/v0/catalog/country/',
        }),
      },
    },
    router: {
      // Base URL where component lives
      url: context.view_url,
    },
  });
  return { app, router, store };
}
